<div class="sisca-login-container">
    <div class="sisca-login-card">

        <div class="sisca-login-logo">
            <img src="./assets/images/SIGA.png" alt="Logo SISCA">
        </div>

        <form (ngSubmit)="buscaUsuario(f,usuario.email,usuario.password); f.resetForm()" #f="ngForm" class="sisca-login-form">

            <div class="sisca-field">
                <label for="email">Usuario</label>
                <input type="email" id="email" name="email" [(ngModel)]="usuario.email" required>
            </div>

            <div class="sisca-field">
                <label for="password">Contraseña</label>
                <input type="password" id="password" name="password" [(ngModel)]="usuario.password" required>
            </div>

            <button type="submit" class="sisca-btn">Iniciar sesión</button>
        </form>

        <footer class="sisca-footer">
            © 2026 CECyTEV | SIGA
        </footer>

    </div>
</div>